import { countries } from 'country-flags-svg';
import { Profile } from 'iconsax-react';

import ActionButton from '@core/components/actionbutton/ActionButton';

import EditIcon from 'assets/icons/edit-icon-filled.svg?url';
import LocationIcon from 'assets/icons/location-icon-bold.svg';
import LanguageIcon from 'assets/icons/language-circle-icon.svg';

import classes from './AboutMe.module.scss';


const AboutMe = ({ data, hasEditButton = false, editClickHandler, isNewStep = true }) => {
	const emptyState = {
		birth_date: !data?.birth_date,
		birth_date_beautify: !data?.birth_date_beautify,
		residential_country_iso: !data?.residential_country_iso,
		about_me: !data?.about_me,
		languages: !data?.languages || (data?.languages && data?.languages.length === 0)
	};
	const isEmpty = Object.values(emptyState).every((val) => val);
	const countryName =
		countries.find((crty) => crty.iso2 === data?.residential_country_iso)?.name || '';
	return (
		<>
			{(!isEmpty || isNewStep) && (
				<section className={`d-flex flex-column gap-2 ${classes['resume-aboutme-wrapper']}`}>
					<div className={`d-flex flex-row justify-content-between ${classes['resume-aboutme-title']}`}>
						<div className='d-flex align-items-center gap-2 ms-4'>
							<Profile />
							<h4 className="d-none d-md-block">About me</h4>
						</div>
						{hasEditButton &&
							<ActionButton kind="simple" onClick={() => editClickHandler('about')}>
								<img src={EditIcon} alt="edit-icon" />
							</ActionButton>
						}
					</div>
					<div
						className={`d-flex flex-column gap-4 ${classes['resume-aboutme-content']} ${isEmpty ? classes['empty-state'] : ''
							}`}>
						<div className='row'>
							<div className='col-lg-8 col-12 mb-3 mb-lg-0'>
								{data?.about_me && <p className={classes['aboutme-parag']}>{data?.about_me}</p>}
							</div>
							<div className='col-lg-4 col-12 d-flex flex-column gap-3'>
								{data?.birth_date_beautify && (
									<div className={`${classes['birth-date']} d-flex flex-row justify-content-between`}>
										<div className="d-flex flex-row gap-3">
											<span>Date of Birth</span>
											<p>{data?.birth_date_beautify}</p>
										</div>
									</div>
								)}
								<span className={`${classes['location']} d-flex flex-row gap-1`}>
									{data?.residential_country_iso && (
										<>
											<LocationIcon />
											{countryName}
										</>
									)}
								</span>
								<div className={`d-flex flex-row ${classes['languages']}`}>
									{data?.languages && data.languages.length > 0 && (
										<div className="d-flex flex-row gap-1">
											<ul>
												{data.languages.map((lang) => (
													<li key={lang?.language?.name} className='mb-3'>
														<LanguageIcon />
														{`${lang?.language?.name} ${lang?.proficiency?.proficiency ? `(${lang?.proficiency?.proficiency})` : ''
															}`}</li>
												))}
											</ul>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</section>
			)}

		</>
	);
};

export default AboutMe;
